import { render, staticRenderFns } from "./BannerNotice.vue?vue&type=template&id=d4563b82&scoped=true&"
import script from "./BannerNotice.vue?vue&type=script&lang=js&"
export * from "./BannerNotice.vue?vue&type=script&lang=js&"
import style0 from "./BannerNotice.vue?vue&type=style&index=0&id=d4563b82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4563b82",
  null
  
)

export default component.exports